module.exports = __webpack_public_path__ + "media/img/about-us/info-bg-87748aa5c6162cb78d9ec489e1ec004c.jpg";